

export const useCurrencyFormatter = () => {
    const numberFormat = new Intl.NumberFormat('nl-NL', {
        currency: 'EUR',
        style: 'currency',
    })

    return numberFormat.format;
}